import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons'
import styles from './DefaultIcon.module.scss'

export const DefaultIcon = ({ className }: { className?: string }) => {
  return (
    <div className={classNames(styles.container, className)}>
      <FontAwesomeIcon icon={faGraduationCap} />
    </div>
  )
}
